<script setup>
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import { computed, inject, watch } from 'vue'
import FullPopup from '#/general/FullPopup'
const {
  showInvalidPotentialPopup,
  searchText,
  searchAddressesEnabled,
  invalidPotentialBuildingClass,
  invalidPotentialBuildingCategory
} = useAnalyzer()
const { pages } = inject('Shared')
watch(showInvalidPotentialPopup, v => {
  if (!v) {
    searchAddressesEnabled.value = true
    searchText.value = null
  }
})

const mappedInvalidPotentialBuildingClass = computed(() => {
  switch (invalidPotentialBuildingClass.value) {
    case '1110': return 'Gebäude mit einer Wohnung'
    case '1121': return 'Gebäude mit zwei Wohnungen'
    case '1122': return 'Gebäude mit drei oder mehr Wohnungen'
    case '1130': return 'Wohngebäude für Gemeinschaften'
    case '1211': return 'Hotelgebäude'
    case '1212': return 'Andere Gebäude für kurzfristige Beherbergung'
    case '1220': return 'Bürogebäude'
    case '1230': return 'Groß- und Einzelhandelsgebäude'
    case '1231': return 'Restaurants und Bars in Gebäuden ohne Wohnnutzung'
    case '1241': return 'Bahnhöfe, Abfertigungsgebäude und Fernsprechvermittlungszentralen'
    case '1242': return 'Garagengebäude'
    case '1251': return 'Industriegebäude'
    case '1252': return 'Behälter,  case Silos:  return und Lagergebäude'
    case '1261': return 'Gebäude für Kultur- und Freizeitzwecke'
    case '1262': return 'Museen und Bibliotheken'
    case '1263': return 'Schul- und Hochschulgebäude Forschungseinrichtungen'
    case '1264': return 'Krankenhäuser und Facheinrichtungen des Gesundheitswesens'
    case '1265': return 'Sporthallen'
    case '1271': return 'Landwirtschaftliche Betriebsgebäude'
    case '1272': return 'Kirchen und sonstige Kultgebäude'
    case '1273': return 'Denkmäler oder unter Denkmalschutz stehende Bauwerke'
    case '1274': return 'Sonstige Hochbauten, anderweitig nicht genannt'
    case '1275': return 'Andere Gebäude für die kollektive Unterkunft'
    case '1276': return 'Gebäude für die Tierhaltung'
    case '1277': return 'Gebäude für den Pflanzenbau'
    case '1278': return 'Andere landwirtschaftliche Gebäude'
  }
  return 'No Valid Error Code'
})

const computedBody = computed(() => {
  let res = pages.value.map.invalidPotentialPopup.body
  res = res.replace('#{invalidPotentialBuildingCategory}', `${invalidPotentialBuildingCategory ? 'Gebäudeklasse' : 'Gebäudekategorie'} ${'<strong>' + mappedInvalidPotentialBuildingClass.value + '</strong>'}`)
  res = res.replace('#{searchText}', searchText.value ? searchText.value : 'No Searched Address')
  return res
})
</script>

<template lang="pug">
full-popup(
  :fixed="false"
  :persistent="true"
  v-model:visible="showInvalidPotentialPopup"
  :btn-label="pages.map.invalidPotentialPopup.btn"
  :title="pages.map.invalidPotentialPopup.title"
)
  div(v-html="computedBody")
</template>

<style lang="sass" scoped>
</style>
